import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';

const CirclePlus = ({ open }) => (jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: `transition-transform duration-300 ease-out ${open ? 'rotate-45' : 'rotate-0'}`, children: [jsx("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "1.5" }), jsx("path", { d: "M12 8v8M8 12h8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
const styles = {
    base: 'w-full border border-(--color-card-border-neutral) bg-(--color-bg-main) py-space-400 pl-space-600 pr-space-500 rounded-radius-200',
    button: 'w-full flex gap-space-600 justify-between items-center text-left hover:cursor-pointer',
    icon: 'flex flex-col justify-between items-center w-8 h-8 text-icon-list-decorative',
    title: 'text-body-strong text-(--color-text-body)',
    bodyContainer: 'w-full overflow-hidden transition-all duration-300 ease-out',
    containerOpen: 'max-h-[1000px] opacity-100',
    containerClosed: 'max-h-0 opacity-0',
    body: 'mt-space-600 text-body text-(--color-text-body)',
};
const Accordion = ({ title, defaultOpen = false, open: controlledOpen, onToggle, children, ...rest }) => {
    const isControlled = controlledOpen !== undefined;
    const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
    const open = isControlled ? controlledOpen : uncontrolledOpen;
    const toggle = () => {
        const next = !open;
        if (!isControlled)
            setUncontrolledOpen(next);
        onToggle?.(next);
    };
    return (jsxs("div", { className: `${styles.base}`, ...rest, children: [jsxs("button", { type: "button", "aria-expanded": open, onClick: toggle, className: styles.button, children: [jsx("span", { className: styles.title, children: title }), jsx("span", { className: styles.icon, "aria-hidden": true, children: jsx(CirclePlus, { open: open }) })] }), jsx("div", { className: `${styles.bodyContainer} ${open ? styles.containerOpen : styles.containerClosed}`, children: jsx("div", { className: styles.body, children: children }) })] }));
};

export { Accordion };
